const GatsbyContainerId = "___gatsby";
const FootnoteId = "disclaimer-footnote";

export { FootnoteId, GatsbyContainerId };
